document.addEventListener("DOMContentLoaded", function() {
    const currentUrl = window.location.href;
    
    // Verifica se a URL corresponde exatamente a "/collections/" ou contém "collections?srsltid="
    if (window.location.pathname === "/collections/" || currentUrl.includes("collections?srsltid=")) {
        window.location.replace("/collections/all-makeup-products");
    }

    if (window.location.pathname === "/pages/trestique-rewards") {
        window.location.replace("/pages/trestique-rewards-program");
    }

    if (window.location.pathname === "/pages/essential-mix") {
        window.location.replace("/products/create-your-makeup-kit-bundle-set");
        console.dir("redirected");
    }


    // Verifica se a URL atual contém 'create-your-makeup-kit-bundle-set'
    if (currentUrl.includes('create-your-makeup-kit-bundle-set')) {
        // Adiciona um listener de clique no body para interceptar todos os cliques
        document.body.addEventListener('click', function(event) {
            // Exibe a mensagem de interceptação
            //const target = event.target.closest('a, button, div');
            //if (target) {
                // Se for um <a> ou <button>, permite o clique (não faz nada)
            //    console.log('Target: ' + target);
            //    return;
            //} else{
            //  console.log('Cliques estão desativados nesta página!');
            //}
            // console.dir(event.target);
            // Previne o comportamento padrão do evento
            // event.preventDefault();
            // Impede a propagação do evento para outros listeners
            // event.stopPropagation();
            // 
            // window.location.replace("/products/create-your-makeup-kit-bundle-set/#");
          
        }, true);
    }
 
  });